export default "__VITE_ASSET__BkF9qOsA__"